import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { TabPanel, TabView } from "primereact/tabview";
import { Button } from "primereact/button";
import { SplitButton } from "primereact/splitbutton";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";

// ------------------- COMPONENTES DE BASE-----------------------------------------------------
import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";
import { downloadFile } from "../../../../Base/Services/ArchivosService";
import ReusableDialog from "../../../../Base/Components/Dialog/ReusableDialog";
import { getListaCorreos } from "../../../../Base/API/IT/ListaCorreos/ListaCorreosRequest";

// ------------------- CONSULTAS A LA API-------------------------------------------------------
import { getProveedorCAI } from "../../../../API/Compras/Proveedores/ProveedoresCAIRequest";
import {
  descargarArchivoBIC,
  descargarArchivoConstancia,
  descargarArchivoEscritura,
  descargarArchivoFactura,
  descargarArchivoFormato,
  descargarArchivoPermiso,
  descargarArchivoRegistro,
  getEnlaceInscripcion,
  getProveedorSinEliminar,
  postChangeEstados,
  updateEnlaceInscripcion,
  postChangeEstadoRevision,
  sendEmailInscripcion,
} from "../../../../API/Compras/Proveedores/ProveedoresRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

// ------------------ COMPONENTES DE NECESARIOS----------------------------------------------
import CrudProveedoresModal from "./ModalProveedores/CrudProveedoresModal";
import CrudProveedoresCAI from "./ModalProveedores/CrudProveedoresCAI";
import { CorreoInscripcion } from "./CorreoInscripcion";
import FormatoInscripcionPDF from "./FormatoInscripcion/FormatoInscripcion";
import ModalSolicitudEdicionProveedor from "./SolicitudesEdicionProveedores/ModalSolicitudEdicionProveedor";
import SolicitudEdicionProveedoresScreen from "./SolicitudesEdicionProveedores/SolicitudEdicionProveedoresScreen";

export const ProveedoresScreen = ({ Finanzas = false }) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const USUARIO_PERMITIDO_EDITAR_PROVEEDOR = 154;
  const puedeEditarProveedorAdmin = Number(userAuth?.IdUser) === USUARIO_PERMITIDO_EDITAR_PROVEEDOR;

  const [proveedores, setProveedores] = useState("");
  const [proveedoresFilter, setProveedoresFilter] = useState([]);
  const [mostrarInactivos, setMostrarInactivos] = useState(false);
  const [proveedoresCAI, setProveedoresCAI] = useState("");
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogCAI, setShowDialogCAI] = useState(false);
  const [showDialogInscripcion, setShowDialogInscripcion] = useState(false);
  const [modo, setModo] = useState(null);

  const [proveedorToShow, setProveedorToShow] = useState(null);
  const [proveedorMail, setProveedorMail] = useState({});
  const [idioma, setIdioma] = useState("es");
  const [correoAEviar, setCorreoAEviar] = useState([]);
  const [loadingCorreo, setLoadingCorreo] = useState(false);
  const [enlace, setEnlace] = useState("");

  const [estados, setEstados] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showDialogFormato, setShowDialogFormato] = useState(false);
  const [proveedorFormato, setProveedorFormato] = useState(null);
  const [tokenFormato, setTokenFormato] = useState(null);
  const [idiomaFormato, setIdiomaFormato] = useState(2);
  const Token = localStorage.getItem("TokenCSM");

  const [estadosRevision, setEstadosRevision] = useState([]);
  const [dialogSolicitudEdicion, setDialogSolicitudEdicion] = useState(false);
  const [proveedorSolicitudEdicion, setProveedorSolicitudEdicion] = useState(null);

  // FUNCION PARA OBTENER INFORMACION DE PROVEEDORES
  const getInfo = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);
    if (activeIndex === 0) {
      const proveedor = await getProveedorSinEliminar();

      setProveedores(proveedor);

      const estadosRevisionTemp =
        await getEstadosCategory("Revision Proveedor");
      setEstadosRevision(
        Array.isArray(estadosRevisionTemp) ? estadosRevisionTemp : [],
      );
    } else if (activeIndex === 1) {
      const proveedorCAI = await getProveedorCAI();
      setProveedoresCAI(proveedorCAI);
    } else if (activeIndex === 2) {
      // El tab de solicitudes carga su propia información internamente.
    }
    setLoading(false);
  };

  const openDialogSolicitudEdicion = (rowData) => {
    setProveedorSolicitudEdicion(rowData);
    setDialogSolicitudEdicion(true);
  };

  const ChangeEstadoEdicion = (IdVendor, Estado) => {
    updateEnlaceInscripcion({ IdVendor, Estado });
    const tempo = proveedores.map((item) => {
      if (item.IdVendor === IdVendor) {
        item.esEditable = Estado;
        toastShow(
          toast,
          "success",
          "Actualizado",
          "Se actualizó el estado de edición del enlace de inscripción del proveedor",
        );
      }
      return item;
    });
    setProveedores(tempo);
  };

  const botonEnviarCorreo = (data) => {
    if (data?.IdVendor) {
      return (
        <div className="d-flex" style={{ textAlign: "center", height: 28 }}>
          {/* BOTÓN DE ENVIAR CORREO */}
          <Button
            className="p-button-text"
            icon="pi pi-envelope"
            tooltip="Enviar correo de inscripción"
            tooltipOptions={{ position: "left" }}
            onClick={async () => {
              setShowDialogInscripcion(true);
              setProveedorMail(data);
              setCorreoAEviar(data?.Email === " " ? [] : [data?.Email]);
              const enlaceT = await getEnlaceInscripcion(
                data.IdVendor,
                userAuth?.IdUser,
              );
              setEnlace({
                enlace: enlaceT[0],
                Email: correoAEviar,
                CustomerName: data?.CustomerName,
              });
            }}
            style={{ padding: "0" }}
          />

          {/* BOTÓN DE SOLICITAR EDICIÓN */}
          <Button
            icon="pi pi-file-edit"
            className="p-button-text"
            tooltip={
              Number(data?.IdStatusRevision) === 67
                ? "No se puede solicitar edición mientras está pendiente"
                : "Solicitar edición"
            }
            tooltipOptions={{ position: "left" }}
            disabled={Number(data?.IdStatusRevision) === 67}
            onClick={() => openDialogSolicitudEdicion(data)}
          />

          {puedeEditarProveedorAdmin && (
            <Checkbox
              style={{ marginTop: 3 }}
              checked={data?.esEditable}
              onChange={(e) =>
                ChangeEstadoEdicion(data?.IdVendor, e.target.checked)
              }
            />
          )}

          {/* IMPRIMIR */}
          <SplitButton
            className="p-button-text"
            icon="pi pi-print"
            tooltip="Imprimir"
            tooltipOptions={{ position: "left" }}
            onClick={async () => {
              const tokenGenerado = await getEnlaceInscripcion(data.IdVendor);

              setProveedorFormato(data.IdVendor);
              setTokenFormato(tokenGenerado);
              setIdiomaFormato(2);
              setShowDialogFormato(true);
            }}
            model={[
              {
                label: "Ingles",
                icon: "pi pi-file-pdf",
                command: async () => {
                  const tokenGenerado = await getEnlaceInscripcion(
                    data.IdVendor,
                  );

                  setProveedorFormato(data.IdVendor);
                  setTokenFormato(tokenGenerado);
                  setIdiomaFormato(1);
                  setShowDialogFormato(true);
                },
              },
              {
                label: "Español",
                icon: "pi pi-file-pdf",
                command: async () => {
                  const tokenGenerado = await getEnlaceInscripcion(
                    data.IdVendor,
                  );

                  setProveedorFormato(data.IdVendor);
                  setTokenFormato(tokenGenerado);
                  setIdiomaFormato(2);
                  setShowDialogFormato(true);
                },
              },
            ]}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  const getArchivo = async (rowData) => {
    const a = await descargarArchivoBIC(
      rowData?.CodigoProveedor,
      rowData?.BICName,
      Token,
    );
    downloadFile(a, rowData?.BICName);
  };

  const getArchivoFactura = async (rowData) => {
    const a = await descargarArchivoFactura(
      rowData?.CodigoProveedor,
      rowData?.FacturaName,
      Token,
    );
    downloadFile(a, rowData?.FacturaName);
  };

  const getArchivoPermiso = async (rowData) => {
    const a = await descargarArchivoPermiso(
      rowData?.CodigoProveedor,
      rowData?.PermisoOperacionesName,
      Token,
    );
    downloadFile(a, rowData?.PermisoOperacionesName);
  };

  const getArchivoEscritura = async (rowData) => {
    const a = await descargarArchivoEscritura(
      rowData?.CodigoProveedor,
      rowData?.EscrituraConstitucionName,
      Token,
    );
    downloadFile(a, rowData?.EscrituraConstitucionName);
  };

  const getArchivoConstancia = async (rowData) => {
    const a = await descargarArchivoConstancia(
      rowData?.CodigoProveedor,
      rowData?.ConstPagosName,
      Token,
    );
    downloadFile(a, rowData?.ConstPagosName);
  };

  const getArchivoRegistro = async (rowData) => {
    const a = await descargarArchivoRegistro(
      rowData?.CodigoProveedor,
      rowData?.RegistroExoneradoName,
      Token,
    );
    downloadFile(a, rowData?.RegistroExoneradoName);
  };

  const getArchivoFormato = async (rowData) => {
    const a = await descargarArchivoFormato(
      rowData?.CodigoProveedor,
      rowData?.FormatoInscripcionName,
      Token,
    );
    downloadFile(a, rowData?.FormatoInscripcionName);
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdVendor: item.IdVendor,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdVendor: data.IdVendor,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Proveedores ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdVendors = changes.map((item) => item.IdVendor);
                cambiarEstadoEjecutar(e.value.IdStatus, IdVendors.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {
                getInfo();
              },
            });
          }}
        />
      </div>
    );
  };

  // CAMBIO DE ESTADO DE REVISION DEL PROVEEDOR
  const changeEstadoRevision = ({ data, api }) => {
    return (
      <Dropdown
        value={estadosRevision.find(
          (e) => e.IdStatus === data.IdStatusRevision,
        )}
        options={estadosRevision}
        optionLabel="StatusName"
        filter
        filterBy="StatusName"
        style={{ width: "100%" }}
        onChange={(e) => {
          confirmDialog({
            message: `¿Cambiar a estado ${e.value.StatusName} al proveedor ${data.CustomerName}?`,
            header: "Confirmación",
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
              await postChangeEstadoRevision({
                IdVendor: data.IdVendor,
                IdStatusRevision: e.value.IdStatus,
              });

              getInfo();
              api.stopEditing();
            },
            reject: () => {
              getInfo();
            },
          });
        }}
      />
    );
  };

  const ChangeEstadoEdicionSinToast = (IdVendor, Estado) => {
    updateEnlaceInscripcion({ IdVendor, Estado });
  };

  // FUNCION PARA ENVIAR CORREO DE INSCRIPCION
  const EnviarCorreoInscripcion = async () => {
    setLoadingCorreo(true);

    try {
      ChangeEstadoEdicionSinToast(proveedorMail.IdVendor, true);

      if (enlace?.enlace) {
        const toEmails = [correoAEviar?.toString()].join(",");

        let AsuntoES = "Actualización de Información – Acción Requerida";
        let AsuntoEN = "Information Update – Action Required";

        const correosTempo = await getListaCorreos();
        let correos = correosTempo.filter((item) => item.IdListaCorreo === 1);

        const correoHtml =
          document.getElementById("CorreoInscripcion")?.innerHTML;

        let objeto = {
          to: toEmails,
          cc: userAuth?.Email,
          bcc: correos[0]?.CCoMail,
          subject: idioma === "es" ? AsuntoES : AsuntoEN,
          html: correoHtml,
          idioma: idioma,
        };

        const result = await sendEmailInscripcion(objeto, Token);

        if (result) {
          toastShow(
            toast,
            "success",
            "Enviado",
            "Correo enviado exitosamente.",
          );

          setProveedorMail(undefined);
          setShowDialogInscripcion(false);
        } else {
          toastShow(toast, "error", "Error", "Correo no enviado.");
        }
      }
    } catch (error) {
      toastShow(
        toast,
        "error",
        "Error",
        "Ocurrió un error al enviar el correo.",
      );
    } finally {
      setLoadingCorreo(false);
    }
  };

  const cambiarEstadoEjecutar = async (IdStatus, IdVendors) => {
    const result = await postChangeEstados({ IdStatus, IdVendors });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
  };

  const colums = [
    // ---------- GENERAL ----------
    {
      field: "IdVendor",
      header: "ID",
      className: "XXsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "CodigoProveedor",
      header: "Código",
      headerEn: "Code",
      className: "Xsmall",
      Sumary: "count",
      Format: "Modal",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "Xsmall",
      Format: "Estado",
      editable: puedeEditarProveedorAdmin,
      cellEditor: changeEstado,
      frozen: true,
      backgroundField: "StatusBackground",
      colorField: "StatusColor",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "CustomerName",
      header: "Nombre Legal",
      headerEn: "Name",
      className: "large",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      // CustomerName Comercial
      field: "NombreComercial",
      header: "Nombre Comercial",
      className: "colum-width-XXlarge",
      body: (rowData) => rowData.NombreComercial,
      Sumary: "count",
    },
    {
      field: "Contact",
      header: "Agente de Compras",
      headerEn: "Purchase Agent",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "CategoryName",
      header: "Categoría",
      headerEn: "Category",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "MonedaPagoName",
      header: "Moneda Pago",
      headerEn: "Payment Currency",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Type",
      header: "Tipo de Pago",
      headerEn: "Payment Type",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    //-------------------------------

    //--------- REVISIÓN ------------
    {
      headerName: "Revisión",
      children: [
        {
          field: "EstadoRevision",
          header: "Estado Revisión",
          headerEn: "Review Status",
          className: "medium",
          filter: true,
          cellEditor: changeEstadoRevision,
          backgroundField: "RevisionBackground",
          colorField: "RevisionColor",
          body: (rowData) => ({
            ID: rowData.IdStatusRevision,
            Estado: rowData.EstadoRevision,
          }),
          Format: "Estado",
          editable: puedeEditarProveedorAdmin,
        },
        {
          field: "UserNameReviso",
          header: "Usuario Revisó",
          headerEn: "Reviewed By",
          className: "large",
          filter: true,
        },
        {
          field: "DateRevision",
          header: "Fecha Revisión",
          headerEn: "Review Date",
          className: "medium",
          filter: true,
          Format: "Datetime",
        },
      ],
    },
    //-------------------------------

    //--------- INFORMACION GENERAL ------------
    {
      headerName: "Información General",
      header: "Información General",
      children: [
        {
          // RTN
          field: "RTN",
          header: "RTN",
          className: "medium",
          // body: (rowData) => rowData.RTN,
          aling: "center",
        },
        {
          // CasaMatriz
          field: "CasaMatriz",
          header: "Casa Matriz",
          className: "Xlarge",
          // body: (rowData) => rowData.CasaMatriz,
        },
        {
          // Country
          field: "Country",
          header: "País",
          className: "small",
          // body: (rowData) => rowData.Country,
        },
        {
          // State
          field: "State",
          header: "Estado",
          className: "small",
          // body: (rowData) => rowData.State,
        },
        {
          // City
          field: "City",
          header: "Ciudad",
          className: "medium",
          // body: (rowData) => rowData.City,
        },
        {
          // Address
          field: "Address",
          header: "Dirección Comercial",
          className: "colum-width-XXlarge",
          // body: (rowData) => rowData.Address,
        },
        {
          // DireccionCasaMatriz
          field: "DireccionCasaMatriz",
          header: "Dirección Casa Matriz",
          className: "Xlarge",
          body: (rowData) => rowData.DireccionCasaMatriz,
        },
        {
          // Tel
          field: "Telefono",
          header: "Teléfono",
          className: "small",
          body: (rowData) => rowData.Tel,
        },
        {
          // Email
          field: "Email",
          header: "Correo",
          className: "medium",
          body: (rowData) => rowData.Email,
        },
        {
          // PrincipalActividadEconomica
          field: "PrincipalActividadEconomica",
          header: "Principal Actividad Económica",
          className: "Xlarge",
          body: (rowData) => rowData.PrincipalActividadEconomica,
        },
        {
          // TipoFactura
          field: "TipoFacturacion",
          header: "Tipo Factura",
          className: "medium",
          body: (rowData) => rowData.TipoFactura,
        },
      ],
    },
    //------------------------------------------

    //---------- REPRESENTANTE LEGAL -----------
    {
      headerName: "Representante Legal",
      children: [
        // INFROMACION DE CONTACTO REPRESENTANTE LEGAL
        {
          // NombreRepresentanteLegal
          field: "NombreRepresentanteLegal",
          header: "Nombre",
          className: "medium",
          body: (rowData) => rowData.NombreRepresentanteLegal,
        },
        {
          // CorreoRepresentanteLegal
          field: "CorreoRepresentanteLegal",
          header: "Correo",
          body: (rowData) => rowData.CorreoRepresentanteLegal,
        },
      ],
    },
    //-----------------------------------------

    //---------- CONTACTO FINANZAS 1 ----------
    {
      headerName: "Contacto finanzas 1",
      children: [
        // INFROMACION DE CONTACTO REPRESENTANTE LEGAL
        {
          // refFin1Nombre
          field: "refFin1Nombre",
          header: "Nombre",
          className: "medium",
          body: (rowData) => rowData.refFin1Nombre,
        },
        {
          // refFin1Telefono
          field: "refFin1Telefono",
          header: "Telefono",
          body: (rowData) => rowData.refFin1Telefono,
        },
        {
          // refFin1Correo
          field: "refFin1Correo",
          header: "Correo",
          body: (rowData) => rowData.refFin1Correo,
        },
      ],
    },
    //-----------------------------------------

    //---------- CONTACTO FINANZAS 2 ----------
    {
      headerName: "Contacto finanzas 2",
      children: [
        // INFROMACION DE CONTACTO REPRESENTANTE LEGAL
        {
          // refFin1Nombre
          field: "refFin2Nombre",
          header: "Nombre",
          className: "medium",
          body: (rowData) => rowData.refFin2Nombre,
        },
        {
          // refFin2Telefono
          field: "refFin2Telefono",
          header: "Telefono",
          body: (rowData) => rowData.refFin2Telefono,
        },
        {
          // refFin2Correo
          field: "refFin2Correo",
          header: "Correo",
          body: (rowData) => rowData.refFin2Correo,
        },
      ],
    },
    //-----------------------------------------

    //---------- BANCO NACIONAL ----------
    {
      headerName: "Banco Nacional",
      children: [
        { field: "NumeroCuentaBancaria" },
        {
          // TitularCuentaBancaria
          field: "TitularCuenta",
          header: "Titular",
          className: "medium",
          body: (rowData) => rowData.TitularCuenta,
        },
        {
          // Banco
          field: "NombreBanco",
          header: "Banco",
          className: "medium",
          body: (rowData) => rowData.Banco,
        },
        {
          // TipoCuenta
          field: "TipoCuenta",
          header: "Tipo Cuenta",
          className: "medium",
          body: (rowData) => rowData.TipoCuenta,
        },
        {
          // CurrencyName
          field: "Currency",
          header: "Moneda",
          className: "small",
          // Format: "Template",
        },
      ],
    },
    //------------------------------------

    //---------- CONTACTO CUENTAS POR COBRAR ----------
    {
      headerName: "Contacto Cuentas por Cobrar",
      children: [
        // INFORMACION DE CONTACTO CUENTAS POR COBRAR
        {
          // ContactoCuentasPorCobrar
          field: "ContactoCuentasPorCobrar",
          header: "Nombre",
          className: "medium",
          body: (rowData) => rowData.ContactoCuentasPorCobrar,
        },
        {
          // CorreoCuentasPorCobrar
          field: "CorreoCuentasPorCobrar",
          header: "Correo",
          className: "medium",
          body: (rowData) => rowData.CorreoCuentasPorCobrar,
        },
        {
          // TelefonoCuentasPorCobrar
          field: "TelefonoCuentasPorCobrar",
          header: "Teléfono",
          className: "medium",
          body: (rowData) => rowData.TelefonoCuentasPorCobrar,
        },
      ],
    },
    //-------------------------------------------------

    //---------- BANCO INTERNACIONAL --------
    {
      headerName: "Banco Internacional",
      children: [
        {
          headerName: "Banco Intermediario",
          children: [
            // INFORMACION BANCARIA INTERNACIONAL
            {
              // BancoIntermediarioNombre
              field: "BancoIntermediarioNombre",
              header: "Banco Intermediario",
              className: "medium",
              body: (rowData) => rowData.BancoIntermediarioNombre,
            },
            {
              // BancoIntermediarioDireccion
              field: "BancoIntermediarioDireccion",
              header: "Dirección",
              className: "colum-width-large",
              body: (rowData) => rowData.BancoIntermediarioDireccion,
            },
            {
              // BancoIntermediarioSwift
              field: "BancoIntermediarioSwift",
              header: "Switf",
              className: "small",
              body: (rowData) => rowData.BancoIntermediarioSwift,
            },
            {
              // BancoIntermediarioAbaBin
              field: "BancoIntermediarioAbaBin",
              header: "ABA / BIN",
              className: "small",
              body: (rowData) => rowData.BancoIntermediarioAbaBin,
            },
          ],
        },
        {
          headerName: "Banco Beneficiario",
          children: [
            {
              // BancoBeneficiarioNombre
              field: "BancoBeneficiarioNombre",
              header: "Nombre",
              className: "medium",
              body: (rowData) => rowData.BancoBeneficiarioNombre,
            },
            {
              // BancoBeneficiarioDireccion
              field: "BancoBeneficiarioDireccion",
              header: "Dirección",
              className: "colum-width-largue",
              body: (rowData) => rowData.BancoBeneficiarioDireccion,
            },
            {
              // BancoBeneficiarioSwift
              field: "BancoBeneficiarioSwift",
              header: "Swift",
              className: "small",
              body: (rowData) => rowData.BancoBeneficiarioSwift,
            },
            {
              // BancoBeneficiarioAbaBin
              field: "BancoBeneficiarioAbaBin",
              header: "ABA / BIN",
              className: "small",
              body: (rowData) => rowData.BancoBeneficiarioAbaBin,
            },
            {
              // BancoBeneficiarioNombreBeneficiario
              field: "BancoBeneficiarioNombreBeneficiario",
              header: "Beneficiario",
              className: "small",
              body: (rowData) => rowData.BancoBeneficiarioNombreBeneficiario,
            },
            {
              // BancoBeneficiarioCuenta
              field: "BancoBeneficiarioCuenta",
              header: "Cuenta",
              className: "medium",
              body: (rowData) => rowData.BancoBeneficiarioCuenta,
            },
          ],
        },
        {
          // CurrencyName
          field: "CurrencyInternacional",
          header: "Moneda",
          className: "small",
          // Format: "Template",
        },
      ],
    },
    //---------------------------------------

    //-------- REFRENCIAS COMERCIALES ----------
    {
      headerName: "Referencias Comerciales",
      children: [
        {
          headerName: "Referencia 1",
          children: [
            // REFERENCIAS COMERCIALES
            {
              // ref1Nombre
              field: "ref1Nombre",
              header: "Nombre",
              className: "medium",
              body: (rowData) => rowData.ref1Nombre,
            },
            {
              // ref1Telefono
              field: "ref1Telefono",
              header: "Teléfono",
              className: "small",
              body: (rowData) => rowData.ref1Telefono,
            },
            {
              // ref1Correo
              field: "ref1Correo",
              header: "Correo",
              className: "medium",
              body: (rowData) => rowData.ref1Correo,
            },
          ],
        },
        {
          headerName: "Referencia 2",
          children: [
            {
              // ref2Nombre
              field: "ref2Nombre",
              header: "Nombre",
              className: "medium",
              body: (rowData) => rowData.ref2Nombre,
            },
            {
              // ref2Telefono
              field: "ref2Telefono",
              header: "Teléfono",
              className: "small",
              body: (rowData) => rowData.ref2Telefono,
            },
            {
              // ref2Correo
              field: "ref2Correo",
              header: "Correo",
              className: "medium",
              body: (rowData) => rowData.ref2Correo,
            },
          ],
        },
      ],
    },
    //------------------------------------------

    //---------- ZONA lIBRE ----------
    {
      headerName: "Zona Libre",
      children: [
        // ZONA LIBRE
        {
          header: "Zona Libre",
          field: "ZonaLibre",
          filter: false,
          className: "Xsmall",
          Format: "Template",
          align: "center",
          body: (rowData) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Checkbox checked={rowData.ZonaLibre} />
            </div>
          ),
        },
        {
          // NombreZonaLibre
          field: "NombreZonaLibre",
          header: "Nombre",
          className: "medium",
          body: (rowData) => rowData.NombreZonaLibre,
        },
        {
          // DireccionZonaLibre
          field: "DireccionZonaLibre",
          header: "Dirección",
          className: "colum-width-XXlarge",
          body: (rowData) => rowData.DireccionZonaLibre,
        },
      ],
    },
    //--------------------------------

    //---------- INFORMACION FINANCIERA ----------
    {
      headerName: "Información Financiera",
      children: [
        {
          header: "Moneda",
          field: "CurrencyFinName",
          className: "small",
        },
        {
          header: "Activos Corrientes",
          field: "ActivosCorrientes",
          className: "medium",
          Format: "Currency",
        },
        {
          header: "Total Activos",
          field: "TotalActivos",
          className: "medium",
          Format: "Currency",
        },
        {
          header: "Pasivos Corrientes",
          field: "PasivosCorrientes",
          className: "medium",
          Format: "Currency",
        },
        {
          header: "Total Pasivos",
          field: "TotalPasivos",
          className: "medium",
          Format: "Currency",
        },
      ],
    },
    //--------------------------------------------

    //---------- ARCHIVOS ----------
    {
      headerName: "Archivos",
      children: [
        {
          field: "BICName",
          header: "BIC",
          className: "large",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.BICName ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => getArchivo(rowData)}
                  tooltip="Descargar BIC"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "FacturaName",
          header: "Factura",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FacturaName ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => getArchivoFactura(rowData)}
                  tooltip="Descargar Factura"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "PermisoOperacionesName",
          header: "Permiso Operación",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.PermisoOperacionesName ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => getArchivoPermiso(rowData)}
                  tooltip="Descargar Permiso"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "EscrituraConstitucionName",
          header: "Escritura Constitución",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.EscrituraConstitucionName ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => getArchivoEscritura(rowData)}
                  tooltip="Descargar Escritura"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "ConstPagosName",
          header: "Constancia Pagos Cuenta",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.ConstPagosName ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => getArchivoConstancia(rowData)}
                  tooltip="Descargar Constancia"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "RegistroExoneradoName",
          header: "Archivo Registro Exonerado",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.RegistroExoneradoName ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => getArchivoRegistro(rowData)}
                  tooltip="Descargar Registro Exónerado"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "FormatoInscripcionName",
          header: "Formato de Inscripción",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FormatoInscripcionName ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => getArchivoFormato(rowData)}
                  tooltip="Descargar Formato"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
      ],
    },
    //------------------------------

    //---------- ACCIONES ----------
    {
      field: "UserName",
      header: "Usuario Creación",
      headerEn: "User Create",
      className: "large",
    },
    {
      field: "IdVendor",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if (rowData?.IdVendor) {
              setShowDialog(true);
              setSelected(rowData);
              setModo("Editar");
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
        {
          icon: "pi pi-plus",
          tooltip: "Agregar CAI",
          onClick: (rowData) => {
            if (rowData?.IdVendor) {
              if (rowData?.IdStatus === 6) {
                toastShow(
                  toast,
                  "warn",
                  "Advertencia",
                  "No se puede agregar CAI a un proveedor Inactivo",
                );
                return;
              }
              setShowDialogCAI(true);
              setSelected(rowData);
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
    {
      field: "IdVendor",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [],
    },
    {
      // EnviarCorreoInscripcion
      field: "Acciones",
      filter: false,
      header: "",
      className: "medium",
      body: (rowData) => botonEnviarCorreo(rowData),
      frozen: "frozen",
      alignFrozen: "right",
      Format: "Template",
      key: "IdVendor",
    },
    //-------------------------------
  ];

  const table = {
    Columns: colums,
    Data: proveedoresFilter,
    loading: loading,
    key: "IdVendor",
    selected: selected,
    setSelected: setSelected,
    showModal: () => {},
  };

  const columsCAI = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdProveedorCAI",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogCAI(true);
        setSelected(data);
      },
    },
    {
      header: "Proveedor",
      headerEn: "Supplier",
      frozen: true,
      field: "CustomerName",
    },
    {
      header: "Nombre Sucursal",
      headerEn: "Branch Name",
      field: "NombreSucursal",
      className: "Xlarge",
      Sumary: "count",
      frozen: true,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogCAI(true);
        setSelected(data);
      },
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      filter: true,
      Format: "Estado",
      backgroundField: "Background",
      colorField: "Color",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "TipoCAI",
      header: "Tipo CAI",
      headerEn: "CAI Type",
      className: "small",
      filter: true,
    },
    {
      header: "Prefijo",
      headerEn: "Prefix",
      field: "Prefijo",
      className: "Xlarge",
    },
    {
      header: "No. CAI",
      headerEn: "No. CAI",
      field: "NoCAI",
      className: "Xlarge",
    },
    {
      header: "Rango Inicial",
      headerEn: "Initial Range",
      field: "RangoInicial",
      Format: "Currency",
      className: "medium",
    },
    {
      header: "Rango Final",
      headerEn: "Final Range",
      field: "RangoFinal",
      className: "medium",
      Format: "Currency",
    },
    {
      header: "Fecha Vencimiento",
      headerEn: "Expiration Date",
      field: "FechaVencimiento",
      Format: "Date",
      className: "large",
    },
    {
      header: "User Edit",
      headerEn: "User Edit",
      field: "UserName",
      className: "large",
    },
    {
      field: "IdVendor",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-plus",
          tooltip: "Agregar CAI",
          onClick: (rowData) => {
            setShowDialogCAI(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const tableCAI = {
    Columns: columsCAI,
    Data: proveedoresCAI,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "proveedor", config.language));
    getInfo();
  }, [activeIndex]);

  useEffect(() => {
    const lista = Array.isArray(proveedores) ? proveedores : [];

    if (mostrarInactivos) {
      setProveedoresFilter(lista);
    } else {
      setProveedoresFilter(lista.filter((item) => item.IdStatus === 5));
    }
  }, [proveedores, mostrarInactivos]);

  return (
    <div
      className="p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Dialog
        visible={showDialogCAI}
        onHide={() => setShowDialogCAI(false)}
        maximizable
        closeOnEscape={false}
      >
        <CrudProveedoresCAI
          selected={selected}
          idProveedorCAI={proveedorToShow}
          showDialogCAI={showDialogCAI}
          setShowDialogCAI={setShowDialogCAI}
          proveedorSeleccionado={selected}
          actualizarProveedoresCAI={getInfo}
        />
      </Dialog>
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header={getLabel(baseLang, "proveedor", config.language)}>
          <Card
            titulo={
              <div className="botones">
                <h3>{getLabel(baseLang, "proveedor", config.language)}</h3>
                <Button icon="pi pi-refresh" onClick={getInfo} />
                <Button
                  icon="pi pi-plus"
                  onClick={() => {
                    setShowDialog(true);
                    setSelected([]);
                    setModo("Crear");
                  }}
                />
                <Button
                  icon={mostrarInactivos ? "pi pi-eye-slash" : "pi pi-eye"}
                  label={
                    mostrarInactivos ? "Ocultar inactivos" : "Mostrar inactivos"
                  }
                  onClick={() => setMostrarInactivos(!mostrarInactivos)}
                />
              </div>
            }
            contenido={
              <div className="p-4" style={{ height: "87vh" }}>
                <AgGrid table={table} />
              </div>
            }
          ></Card>
        </TabPanel>
        <TabPanel header={getLabel(baseLang, "proveedorCAI", config.language)}>
          <Card
            titulo={
              <div className="botones">
                <h3>{getLabel(baseLang, "proveedorCAI", config.language)}</h3>
                <Button icon="pi pi-refresh" onClick={getInfo} />
              </div>
            }
            contenido={
              <div className="p-4" style={{ height: "87vh" }}>
                <AgGrid table={tableCAI} />
              </div>
            }
          ></Card>
        </TabPanel>
        <TabPanel header="Proveedores Solicitud Edición">
          <SolicitudEdicionProveedoresScreen />
        </TabPanel>
      </TabView>

      {/* MODAL DE CRUD DE PROVEEDORES */}
      {showDialog && (
        <CrudProveedoresModal
          toastRef={toast}
          proveedoresDialog={showDialog}
          proveedores={selected}
          setProveedoresDialog={setShowDialog}
          getProveedores={getInfo}
          modo={modo}
          setSelected={setSelected}
        />
      )}

      {/* DIALOGO DE INSCRIPCION */}
      {showDialogInscripcion && (
        <ReusableDialog
          visible={showDialogInscripcion}
          onHide={() => {
            if (loadingCorreo) return;

            setShowDialogInscripcion(false);
            setProveedorMail(undefined);
          }}
          header={"Enviar Correo a proveedor"}
          ejecutar={() => {
            EnviarCorreoInscripcion();
          }}
          Id={proveedorMail?.IdVendor}
          enlace={`${window.location.origin}${process.env.REACT_APP_ENV}/inscripcionProveedor/${idioma}/${enlace?.enlace}`}
          correoAEnviar={correoAEviar}
          setCorreoAEnviar={setCorreoAEviar}
          idioma={idioma}
          setIdioma={setIdioma}
          loading={loadingCorreo}
        />
      )}

      {/* CORREO DE INSCRIPCION */}
      <div style={{ display: "none" }}>
        <div id="CorreoInscripcion">
          <CorreoInscripcion
            enlace={enlace?.enlace}
            proveedor={enlace?.CustomerName}
            idioma={idioma}
          />
        </div>
      </div>

      {/* MODAL DE FORMATO DE INSCRIPCION PDF */}
      {showDialogFormato && (
        <FormatoInscripcionPDF
          setShowDialogFormato={setShowDialogFormato}
          showDialogFormato={showDialogFormato}
          Numero={proveedorFormato}
          Idioma={idiomaFormato}
          Token={tokenFormato}
        />
      )}

      {/* MODAL DE SOLICITUD DE EDICIÓN */}
      {dialogSolicitudEdicion && (
        <ModalSolicitudEdicionProveedor
          visible={dialogSolicitudEdicion}
          onHide={() => setDialogSolicitudEdicion(false)}
          proveedorData={proveedorSolicitudEdicion}
          IdStatus={proveedorSolicitudEdicion?.IdStatus}
          onSuccess={getInfo}
          toast={toast}
        />
      )}
    </div>
  );
};

export default ProveedoresScreen;
